export const PATIENT_TABS = [
  {
    key: 'new-patient-information',
    label: 'newPatientInformation',
    index: 1,
    active: true,
  },
  {
    key: 'diseases-information',
    label: 'diseasesInformation',
    index: 2,
    active: false,
  },
  {
    key: 'habits',
    label: 'habits',
    index: 3,
    active: false,
  },
  {
    key: 'goals',
    label: 'goals',
    index: 4,
    active: false,
  },
  {
    key: 'case-setting',
    label: 'case-setting',
    index: 5,
    active: false,
  },
  {
    key: 'summary',
    label: 'summary',
    index: 6,
    active: false,
  },
];
